module.exports = __webpack_public_path__ + "static/img/banner.4e160b81.png";